export default "__VITE_ASSET__CdG8ePTZ__"